import cloneDeep from 'lodash/cloneDeep';

const contentFilterFields = {
  userProgress: 'userProgress',
  userClass: 'userClass',
  page: 'page',
  incompletePage: 'incompletePage',
  quizScore: 'quizScore',
  quizProfile: 'quizProfile',
  profile: 'profile'
};

const accessFilterFields = {
  userPurchaseDate: 'userPurchaseDate',
  userFirstAccess: 'userFirstAccess',
  userLastAccess: 'userLastAccess',
  userStatus: 'userStatus',
  accessPlusAll: 'accessPlusAll',
  userPlusAccess: 'userPlusAccess'
};

const userFilterFields = {
  userLocale: 'userLocale',
  userName: 'userName',
  userEmail: 'userEmail',
  userType: 'userType',
  userJoinType: 'userJoinType',
  userEngagement: 'userEngagement'
};

const initialFiltersCounters = {
  accessFilterCount: 0,
  userFilterCount: 0,
  contentFilterCount: 0,
  totalFilterCount: 0
};

const initialFilters = {
  accessFilter: {
    userPurchaseDate: {
      _type: 'user_purchase_date',
      dateFilterType: '',
      from: '',
      until: ''
    },
    userFirstAccess: {
      _type: 'user_first_access',
      dateFilterType: '',
      from: '',
      until: ''
    },
    userLastAccess: {
      _type: 'user_last_access',
      dateFilterType: '',
      from: '',
      until: ''
    },
    userStatus: {
      _type: 'user_status',
      query: ''
    },
    userPlusAccess: {
      _type: 'user_plus_access',
      value: ''
    },
    accessPlusAll: {
      _type: 'user_plus_access',
      option: ''
    }
  },
  userFilter: {
    userName: {
      _type: 'user_name',
      query: ''
    },
    userEmail: {
      _type: 'user_email',
      query: ''
    },
    userLocale: {
      _type: 'user_locale',
      query: ''
    },
    userJoinType: {
      _type: 'user_join_type',
      query: ''
    },
    userType: {
      _type: 'user_type',
      query: ''
    },
    userEngagement: {
      _type: 'user_engagement',
      min: 0,
      max: 4,
      queryData: false
    }
  },
  contentFilter: {
    userProgress: {
      _type: 'user_progress',
      min: 0,
      max: 100,
      queryData: true
    },
    userClass: {
      _type: 'user_class',
      ids: []
    },
    quizProfile: {
      _type: 'quiz_profile',
      id: '',
      profileId: ''
    },
    quizScore: {
      _type: 'quiz_score',
      ids: [],
      min: 0,
      max: 100,
      queryData: true
    },
    page: {
      _type: 'page',
      ids: [],
      completed: true,
      queryData: true
    },
    incompletePage: {
      _type: 'page',
      ids: [],
      completed: false,
      queryData: true
    }
  }
};

const initialFiltersValue = {
  ...initialFiltersCounters,
  ...initialFilters
};

const initialState = {
  deepSearch: cloneDeep(initialFiltersValue),
  deepSearchLoading: false,
  deepSearchOpened: false,
  error: false,
  isDirty: false,
  lastSearchParameters: { filters: [] },
  loadingSearch: false,
  menuSelected: { content: true, access: false, user: false },
  saveDone: false,
  saveLoading: false,
  searchDone: false,
  simpleFilterParams: { _type: 'simple', query: '' }
};

const filters = {
  accessFilter: 'accessFilter',
  userFilter: 'userFilter',
  contentFilter: 'contentFilter'
};

const menus = {
  content: 'content',
  access: 'access',
  user: 'user'
};

export {
  accessFilterFields,
  contentFilterFields,
  filters,
  initialFilters,
  initialFiltersValue,
  initialState,
  menus,
  userFilterFields
};
